var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tmpWrap"
  }, [_c('button', {
    on: {
      "click": _vm.printReady
    }
  }, [_vm._v(" print ")]), _c('Loading', {
    attrs: {
      "visible": _vm.loading
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }